import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import { Toaster } from '@/components/ui/Toaster'
import { lazyWithRetry } from '@/utils/lazyWithRetry'

// Lazy load all pages for faster initial load
const HomePage = lazy(() => lazyWithRetry(() => import('@/pages/HomePage'), 'HomePage'))
const CreateEventPage = lazy(() => lazyWithRetry(() => import('@/pages/CreateEventPage'), 'CreateEventPage'))
const EventPage = lazy(() => lazyWithRetry(() => import('@/pages/EventPage'), 'EventPage'))
const ResponsePage = lazy(() => lazyWithRetry(() => import('@/pages/ResponsePage'), 'ResponsePage'))
const ResultsPage = lazy(() => lazyWithRetry(() => import('@/pages/ResultsPage'), 'ResultsPage'))
const ConfirmationPage = lazy(() => lazyWithRetry(() => import('@/pages/ConfirmationPage'), 'ConfirmationPage'))
const MyEventsPage = lazy(() => lazyWithRetry(() => import('@/pages/MyEventsPage'), 'MyEventsPage'))
const NotFoundPage = lazy(() => lazyWithRetry(() => import('@/pages/NotFoundPage'), 'NotFoundPage'))

// Loading spinner component
function PageLoader() {
  return (
    <div className="app-shell flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4"></div>
        <p className="text-gray-400">Loading...</p>
      </div>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/create" element={<CreateEventPage />} />
            <Route path="/event/:eventId" element={<EventPage />} />
            <Route path="/event/:eventId/respond" element={<ResponsePage />} />
            <Route path="/event/:eventId/results" element={<ResultsPage />} />
            <Route path="/event/:eventId/confirm" element={<ConfirmationPage />} />
            <Route path="/my-events" element={<MyEventsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
        <Toaster />
      </div>
    </BrowserRouter>
  )
}

export default App
